import React, { useState } from "react";
import { Check, Export } from "@phosphor-icons/react";

// Compact circular "share" button — copies the public /opp/{id} URL to the
// clipboard and morphs to a green check for 1.5s as feedback.
const ShareOppButton = ({ oppId, testId }) => {
  const [copied, setCopied] = useState(false);
  return (
    <span
      role="button"
      tabIndex={0}
      onClick={async (e) => {
        e.stopPropagation();
        const url = `${window.location.origin}/opp/${oppId}`;
        try {
          await navigator.clipboard.writeText(url);
          setCopied(true);
          setTimeout(() => setCopied(false), 1500);
        } catch {
          /* noop */
        }
      }}
      onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.click(); }}
      className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white border border-zinc-200 text-zinc-500 hover:border-violet-400 hover:text-violet-700 transition-colors cursor-pointer"
      title="Copy shareable link"
      data-testid={testId}
    >
      {copied ? <Check size={12} weight="bold" /> : <Export size={12} weight="bold" />}
    </span>
  );
};

export default ShareOppButton;
